<template>
  <v-dialog
    max-width="1000px"
    :model-value="show"
    @update:model-value="$emit('update:show', $event)"
    :fullscreen="$vuetify.display.xs"
  >
    <v-card>
      <div class="card-top p-2">
        <span class="card-title">Parent Reminder E-Mail</span>
        <v-btn @click="$emit('update:show', false)" icon size="large"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <div class="card-body p-3">
        <p>
          When a parent makes appointments online, PTC Wizard will send them a confirmation email
          with their schedule.
          <br />
          This email will have the parents schedule and instructions for signing back into PTC
          Wizard to make changes. You also have the ability to modify some of the content of this
          email by typing into the text area below.
          <br />
          We will insert your text into our email that goes to the parent.
          <br />
          Below is a template of the confirmation email that we send with a text area for you to
          write your own message.
        </p>

        <div>
          <span>Schedule For: </span>
          <b>{{ "<<" }}Parent First Name{{ ">>" }}</b>
        </div>
        <v-textarea
          color="primary"
          variant="outlined"
          label="Message"
          placeholder="Type your message here"
          :rows="5"
          :model-value="eventDay.reminder_email_message"
          @update:model-value="
            $emit('update:eventDay', {
              reminder_email_message: $event
            })
          "
        ></v-textarea>
        <div class="table-overflow-hide">
          <div class="directoryTable scrollable-55vh" style="max-height: 55vh; height: auto">
            <table class="table">
              <thead class="sticky-header">
                <tr>
                  <th>School</th>
                  <th>Conference</th>
                  <th>Child</th>
                  <th>Meeting</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Room</th>
                  <th>Virtual Room</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 3" :key="i">
                  <th>School Name</th>
                  <th>Event Name</th>
                  <th>Child Name</th>
                  <th>Teacher/ Team</th>
                  <th>{{ confStore.getDayJs(eventDay.start).format("MM/DD/YYYY") }}</th>
                  <th>
                    {{
                      new Date(Date.now() - (new Date().getMinutes() % 10) * 60000 + eventDay.time_interval * i * 60000).toISOString().slice(11, 16)
                    }}
                  </th>
                  <th>{{ (Math.floor(Math.random() * 60) + 10) * i }}</th>
                  <th><a href="" target="_blank">Virtual Room</a></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="d-flex align-center gap-4 flex-wrap">
          <span style="font-weight: 600; color: rgb(150, 150, 150)">Send Reminder On:</span>
          <DatePicker
            style="max-width: 205px"
            :min="new Date()"
            :model-value="
              eventDay.reminder_email_tstamp ? new Date(eventDay.reminder_email_tstamp) : new Date()
            "
            @update:model-value="
              $emit('update:eventDay', {
                reminder_email_tstamp: confStore.getDayJs($event).format(`YYYY-MM-DD HH:mm:ss`)
              })
            "
            type="datetime-local"
            color="primary"
          ></DatePicker>
        </div>
        <div>
          <v-btn @click="save" :loading="state.loadingSave" style="text-transform: capitalize"
            >Save</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import type { ConferenceDay } from "@/api_types/teacher";
import DatePicker from "@/components/datePicker.vue";
import { useConferenceStore } from "@/stores/teacher/conference";
// import dayjs from "dayjs";
import { reactive } from "vue";

const props = defineProps<{
  show: boolean;
  eventDay: ConferenceDay;
}>();

const state = reactive({
  loadingSave: false
});

defineEmits<{
  (event: "update:show", val: boolean): void;
  (event: "update:eventDay", val: Partial<ConferenceDay>);
}>();

const confStore = useConferenceStore();

const save = async () => {
  state.loadingSave = true;
  console.log(confStore.getDayJs(props.eventDay.reminder_email_tstamp));
  const res = await confStore.apiUpdateConferenceDay(props.eventDay.conference_days_id, {
    reminder_email_message: props.eventDay.reminder_email_message,
    reminder_email_tstamp: props.eventDay.reminder_email_tstamp
  });
  if (res?.conference_days_id)
    confStore.updatedConferenceDay(res.conference_id, res.conference_days_id, {
      reminder_email_message: res.reminder_email_message,
      reminder_email_tstamp: res.reminder_email_tstamp
    });
  state.loadingSave = false;
};
</script>

<style lang="scss" scoped>
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.card-top {
  display: flex;
  align-items: center;
  background-color: $primary;
  min-width: 100%;
  justify-content: space-between;
  .card-title {
    font-weight: 600;
    font-size: 1.25rem;
    margin: auto 0 auto 20px;
    color: white;
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.scrollable-55vh {
  max-height: 55vh;
  height: 55vh;
  overflow: auto;
  margin-top: 1rem;
  .table {
    margin-top: 0;
  }
}

.table-overflow-hide {
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: 1rem;
  .scrollable-55vh {
    margin-top: 0;
    .table {
      margin-top: 0;
    }
  }

  border: solid 1px $gray-300;
  .directoryTable {
    border: unset;
  }
}
.directoryTable {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: solid 1px $gray-300;
  table {
    margin-top: 1rem;
    width: 100%;
    margin-bottom: 0;
    color: #212529;
    vertical-align: top;
    border-color: #dee2e6;
    background-color: $white;

    thead th {
      font-weight: $font-weight-medium;
      white-space: nowrap;
      color: $gray-600;
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.075em;
    }
    tbody {
      border-top: none !important;
      td {
        vertical-align: middle;
      }
      td:first-child {
        width: 28px;
      }
      td:nth-child(2) {
        width: 250px;
      }
    }
    .icon {
      width: 75px;
      height: 25px;
    }
    > :not(caption) > * > * {
      background-color: unset; //remove BS default
    }
  }
  + h3 {
    margin-top: 3rem;
  }

  .sticky-header tr {
    position: sticky;
    top: 0;
    background-color: $gray-200;
    z-index: 1; /* Increase the z-index value */
    th {
      // color: $white !important;
      font-size: medium !important;
      font-size: 0.85rem;
      // padding: unset;
      vertical-align: middle;
      // text-align: center;
    }
  }
  border-collapse: separate;
  border-spacing: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
